import { HttpMethod, HttpRepository } from "../../core/repository/http_repository";
import { CurrentUser } from "./authorization_model";
export class AuthorizationHttpRepository extends HttpRepository {
  me = () => this._jsonRequest<{ user: CurrentUser }>(HttpMethod.GET, "/auth/me");
  login = (username: string, password: string) => this._jsonRequest<{ user: CurrentUser; csrfToken: string }>(HttpMethod.POST, "/auth/login", { username, password });
  logout = () => this._jsonRequest<{ ok: boolean }>(HttpMethod.POST, "/auth/logout");
}
